import React from "react";
import "../assets/css/component-next-step-progress.css";
import { FaCheck } from "react-icons/fa";
import { FaFlag, FaImage } from "react-icons/fa6";
import { HiMiniUserGroup } from "react-icons/hi2";

const steps = [
  {
    icon: <FaFlag />,
    label: "Début",
  },
  {
    icon: <HiMiniUserGroup />,
    label: "Membres",
  },
  {
    icon: <FaImage />,
    label: "Image",
  },
];

export default function ProgressStep({ idx }) {
  return (
    <>
      <div className="main">
        <ul className="ma-ul">
          {steps.map((step, index) => (
            <li className="ma-li" key={index}>
              <span className="icons awesome">{step.icon}</span>
              <p className="mon-p label text-capitalize">{step.label}</p>
              {index === 0 ? (
                <>
                  <span className="step-debut bg-bleu-sombre">{index + 1}</span>
                </>
              ) : (
                <>
                  <div
                    className={`step step-${index + 1} ${
                      index <= idx ? "active" : ""
                    }`}
                  >
                    <p className="text-primary">{index + 1}</p>
                    <FaCheck className="awesome" />
                  </div>
                  <p className="label text-capitalize">{step.label}</p>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
